import { ReactNode, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { setCustomerCreateRequestField, setCustomerUpdateRequestField } from "../../../pages/clienti/feature/slice";
import { setAuthorityOffices } from "../../../pages/clienti/slice";
import { GetHeadQuarter, resetGetAllSot } from "../../../pages/sot/slice";
import { OptionType } from "../../../utils";
import { TrashIcon } from "../../icons/trash";
import { ButtonComponent } from "../../molecules/button/newButton";
import { MadfarmStaticSelect } from "../../molecules/select/newSelect/static";

interface Props {
  mode?: "create" | "edit"
}

export function AuthorityOffices({ mode }: Props) {

  const customerState = useAppSelector((state) => state.customer);
  const sotState = useAppSelector(state => state.headQuarter)
  const dispatch = useAppDispatch();

  const [headquarter, setHeadquarters] = useState<OptionType[]>([])

  let offices: ReactNode[] = [];

  useEffect(() => {
    dispatch(GetHeadQuarter(sotState.sotFilters))
  }, [])

  useEffect(() => {
    if (sotState.responseHeadQuarterStatus === 'successfully') {
      if (sotState.responseHeadQuarter) {
        const data = sotState.responseHeadQuarter.data
        const newObjects: OptionType[] = data.map(d => {
          return { value: d.id, label: `${d.code}` } as OptionType
        })
        setHeadquarters(newObjects)
      }

      dispatch(resetGetAllSot())
    }
  }, [sotState.responseHeadQuarterStatus])

  const customerEditOrCreate = mode === "create" ? customerState.customerCreateRequest : customerState.customerUpdateRequest

  if (
    customerEditOrCreate.headQuarterIds !== undefined &&
    customerEditOrCreate.headQuarterIds.length > 0
  ) {
    customerEditOrCreate.headQuarterIds.forEach((element, index) => {
      offices.push(
        <div
          key={index}
          className="flex items-center gap-3 w-full"
        >
          <MadfarmStaticSelect
            noOptionsMessage=""
            error={!!customerState.customerCreateErrors.headQuarterIds}
            errorLabel="Scegliere SOT"
            placeholder="Sede di competenza"
            options={headquarter}
            defaultValue={element}
            value={element}
            onChange={(value) => {
              //@ts-ignore
              const newValue = value !== null ? value.value : null
              const newOffice = [...customerEditOrCreate.headQuarterIds!];
              newOffice[index] = newValue;
              if (mode === "create") {
                dispatch(setCustomerCreateRequestField({ field: 'headQuarterIds', value: newOffice }))
              } else {
                dispatch(setCustomerUpdateRequestField({ field: 'headQuarterIds', value: newOffice }))
              }
            }}
          />
          <button
            className="flex-shrink-0 p-2 rounded-[8px] hover:bg-neutral-200 transition-colors"
            onClick={() => {
              let newOffices = [...customerEditOrCreate.headQuarterIds!];
              newOffices = newOffices
                .slice(0, index)
                .concat(newOffices.slice(index + 1));
              dispatch(
                setAuthorityOffices(newOffices.length === 0 ? [""] : newOffices)
              );
            }}
          >
            <TrashIcon color="#8383AD" size={24} />
          </button>
        </div>
      );
    });
  }

  return (
    <div className='flex flex-col gap-4'>
      {
        customerState.customerCreateErrors.headQuarterIds && (
          <span className='text-left text-label-md font-semibold text-red-500'>Scegliere almeno una sede</span>
        )
      }
      {offices}
      <div>
        <ButtonComponent
          onClick={() => {
            const newOffices = [...customerEditOrCreate.headQuarterIds!]
            newOffices.push('')
            if (mode === "create") {
              dispatch(setCustomerCreateRequestField({ field: 'headQuarterIds', value: newOffices }))
            } else {
              dispatch(setCustomerUpdateRequestField({ field: 'headQuarterIds', value: newOffices }))
            }
          }}
          label="Aggiungi sede"
          size="sm"
          iconPosition="off"
          variant="outline"
          color="blue"
        />
      </div>
    </div>
  )
}
